import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { cn } from "@shortsworks/ui/lib/utils";
import { NumberInputSchema } from "@app/components/forms/types/schema";

export const FormNumber = ({
  form,
  schema,
  ...rest
}: FormItemProps<NumberInputSchema>) => {
  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border && "rounded-md border p-3 shadow-sm",
            schema.behavior?.hidden && "hidden",
          )}
        >
          <div
            className={cn(
              "space-y-2",
              schema.layout === "horizontal" &&
                "flex flex-row items-start justify-between space-x-2 space-y-0",
            )}
          >
            <div className="flex flex-col space-y-1">
              <FormLabel>
                {typeof schema.label === "function"
                  ? schema.label(form.getValues())
                  : schema.label}
              </FormLabel>
              {schema.layout === "horizontal" && schema.description && (
                <FormDescription>{schema.description}</FormDescription>
              )}
            </div>
            <FormControl>
              <Input
                className="w-20"
                type="number"
                placeholder={schema.placeholder}
                {...field}
                {...schema.behavior}
                min={schema.min || undefined}
                max={schema.max || undefined}
              />
            </FormControl>
            {schema.layout !== "horizontal" && schema.description && (
              <FormDescription>
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
